import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Box,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import DefaultImage from "../../assets/Icon/Default.png";
import ThreeDotMenu from "./Options";
import PdfDetails from "../Custom/PdfDetails";
const useStyles = makeStyles(() => ({
  title: {
    fontSize: "11px !important",
    fontWeight: "700 !important",
    lineHeight: "18px",
    textAlign: "start",
  },
  value: {
    fontSize: "11px !important",
    fontWeight: "400 !important",
    lineHeight: "18px",
    textAlign: "start",
  },
  fileText: {
    fontSize: "15px !important",
    color: "#827F7F",
    fontWeight: "700 !important",
    lineHeight: "18px",
  },
  iconButton: {
    position: "absolute",
    top: 0,
    right: 0,
  },
  deleteButton: {
    position: "absolute",
    bottom: 10,
    right: 0,
  },
  customButtonStyle: {
    fontSize: "14px !important",
    color: "white !important",
    textTransform: "none !important",
    width: "100%",
    height: "30px",
  },
  customButtonSaleStyle: {
    fontSize: "12px !important",
    color: "#000000 !important",
    textTransform: "none !important",
    border: "1px solid #A5A5A5 !important",
    width: "100%",
    height: "30px",
  },
}));

const CustomCard = ({
  id,
  t,
  data,
  file,
  handlePrimaryButton,
  handleSecondaryButton,
  secondaryButtonLabel,
  handleEditClick,
  handleDelete,
  primaryLabel,
  loanData,
  clickable,
  handleClickNavigate,
  loan_request_id,
  image_size,
  flag,
  showPDFDetails,
  disableChange,
  hideEdit,
}) => {
  const classes = useStyles();
  const handleClick = () => {
    if (clickable) {
      handleClickNavigate && handleClickNavigate(id, loan_request_id);
    }
  };
  const handlePrimaryButtonClick = () => {
    handlePrimaryButton && handlePrimaryButton(id);
  };

  const handleSecondaryButtonClick = () => {
    handleSecondaryButton && handleSecondaryButton(id);
  };
  const imageHeight = image_size === true ? 80 : 136;
  return (
    <Card
      onClick={handleClick}
      sx={{
        display: "flex",
        border: "1px solid #A5A5A5",
        marginTop: flag ? "0px" : "20px",
        padding: "0 0 10px 0",
      }}
    >
      <CardContent
        sx={{
          padding: "4px",
          "&:last-child": {
            paddingBottom: handlePrimaryButton ? "24px" : "4px",
          },
          width: "100%",
        }}
      >
        <Grid container>
          {file !== undefined && (
            <Grid
              item
              xs={4}
              sx={{
                paddingRight: "0px",
                marginTop: "20px",
                borderRadius: "10px",
              }}
            >
              <img
                src={file || DefaultImage}
                style={{
                  width: "106px",
                  height: `${imageHeight}px`,
                  borderRadius: "6px",
                }}
                alt="custom-card"
              />
            </Grid>
          )}
          <Grid
            item
            xs={file !== undefined ? 7 : 11}
            sx={{ paddingLeft: "12px", marginTop: "15px" }}
          >
            <Grid container spacing={0} sx={{ height: "80%" }}>
              {Object.entries(data).map(([key, value]) => (
                <React.Fragment key={key}>
                  <Grid
                    item
                    xs={file !== undefined ? 7 : 5}
                    sx={{ padding: "0px" }}
                  >
                    <Typography className={classes.title} gutterBottom>
                      {t(key)}
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography className={classes.value}>:</Typography>
                  </Grid>
                  <Grid item xs={4} sx={{ padding: "0px" }}>
                    <Typography className={classes.value} gutterBottom>
                      {value !== undefined && value !== null ? value : "N/A"}
                    </Typography>
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
            {handlePrimaryButton && (
              <Box
                sx={{
                  display: "flex",
                  gap: "10px",
                  margin: flag ? "0px" : "inherit",
                  marginBottom: "10px",
                }}
              >
                {handleSecondaryButton && (
                  <Button
                    className={classes.customButtonSaleStyle}
                    onClick={handleSecondaryButtonClick}
                  >
                    {secondaryButtonLabel || t("View")}
                  </Button>
                )}
                <Button
                  className={classes.customButtonStyle}
                  variant="contained"
                  onClick={handlePrimaryButtonClick}
                >
                  {primaryLabel || t("View")}
                </Button>
              </Box>
            )}
          </Grid>
          {!loanData && (
            <Grid item xs={1}>
              {showPDFDetails ? (
                <PdfDetails />
              ) : (
                <>
                  {!disableChange && (
                    <ThreeDotMenu
                      onEdit={handleEditClick}
                      onDelete={handleDelete}
                      hideEdit={hideEdit}
                    />
                  )}
                </>
              )}
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CustomCard;
